const validateLocalStorageItemExistence = (item) =>
  localStorage.getItem(item) !== null;

export default validateLocalStorageItemExistence;
